import { Copy } from "lucide-react";

type CopyableCellProps = { children: React.ReactNode };

export const CopyableCell = ({ children }: CopyableCellProps) => (
  <span className="inline-flex items-center gap-1 group w-full min-w-0">
    <span className="truncate">{children}</span>
    <Copy className="h-3 w-3 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity shrink-0" />
  </span>
);
